/*
 *
 *  remotes
 *
 */

import api from "../../helpers";

/**
 *
 * @param {string} metaData
 * @returns
 */

export async function loadEmployeeLeaveRecordAPI(searchFilter) {
  return await api
    .post(`/auth/leavereport`, searchFilter)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}

export async function loadEmployeeListAPI(searchFilter) {
  return await api
    .post(`/auth/employee/getallemployee`, searchFilter)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}

export async function loadDocumentAPI(searchFilter) {
  return await api
    .post(`/auth/documentbyid/${searchFilter}`)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}


export async function loadAttendanceViewAPI(searchFilter) {
  return await api
    .post(`/auth/attendance/getattendancedetails`, searchFilter)
    .then((response) => response)
    .catch((error) => Promise.reject(error));
}

export async function loadProjectListAPI(projectarg){
  return await api
  .post(`/auth/employee/projectreport`,projectarg)
  .then((resp)=>resp.data)
  .catch((error)=>Promise.reject(error));
}


export async function loadEmployeeDropdownAPI(metaData, method, leave) {
  if (leave) {
    return await api
      .post(`/auth/employee/get${metaData}`)
      .then((response) => response.data)
      .catch((error) => Promise.reject(error));
  } else if(method ==="post") {
    return await api
      .post(`/protected/get${metaData}`)
      .then((response) => response.data)
      .catch((error) => Promise.reject(error))
  }
}

const remotes = {
  loadEmployeeLeaveRecordAPI,
  loadEmployeeListAPI,
  loadEmployeeDropdownAPI,
  loadAttendanceViewAPI,
  loadProjectListAPI,
  loadDocumentAPI
};

export default remotes;
